function FeesCtrl() {
  const vm = this;

  vm.config = vm.config || {};
  vm.config.add = function () {
    vm.addFee();
  };
  vm.fees = vm.config.fees || [];

  vm.feeTypes = [{
    key: 'Flat',
    value: 'FLAT'
  }, {
    key: 'Percent',
    value: 'PERCENT'
  }];

  vm.addFee = function addFee($event) {
    if ($event) $event.preventDefault();

    vm.fees.push({
      name: `Fee ${(vm.fees.length + 1)}`,
      type: vm.feeTypes[1].value,
      taxable: false,
      amount: 10
    });
  };

  vm.removeFee = function removeFee(fee) {
    if (!fee) return;

    const feeIndex = vm.fees.indexOf(fee);

    if (feeIndex >= 0) {
      vm.fees.splice(feeIndex, 1);
    }
  };
}

FeesCtrl.$inject = [];

export default FeesCtrl;



// WEBPACK FOOTER //
// ./src/directives/fees/controller.js